<template>
  <section
    class="fixed md:hidden top-0 left-0 w-full flex flex-col text-gray-300 z-30 shadow-black"
  >
    <router-link to="/" class="bg-[#33343D]">
      <picture class="contents">
        <source srcset="/images/logo-trans-small-235x58.webp" type="image/webp" />
        <img
        width="207"
        height="57"
        src="/images/logo-trans-small-235x58.png"
        class="xl:-mt-[10px]"
        />
      </picture>
    </router-link>
    <div class="absolute right-3 top-2" @click="toggleMenu">
      <div class="mr-1 mt-2" v-if="!menuOpen">
        <div class="w-6 h-1 bg-white my-1"></div>
        <div class="w-6 h-1 bg-white my-1"></div>
        <div class="w-6 h-1 bg-white my-1"></div>
      </div>
      <span class="text-white text-3xl font-russo mr-1" v-if="menuOpen">X</span>
    </div>
    <!-- v-show, not v-if: with v-if the whole mobile nav is absent from the
         prerendered HTML, so a mobile-first crawler sees no nav links at all. -->
    <div class="flex flex-col h-full bg-black py-8" v-show="menuOpen">
      <div class="p-6 hover:text-white text-xl font-electro">
        <router-link to="/download" class="download" @click="toggleMenu"
          ><span>DOWNLOAD RALLY NAVIGATOR</span></router-link
        >
      </div>
      <div class="flex flex-col w-full mx-auto font-[Electrolize] bg-black">
        <ul
          class="text-gray-300 py-2 flex flex-col text-[18px] uppercase items-center gap-4"
        >
          <li class="px-3">
            <router-link to="/rally-roadbook" @click="toggleMenu"
              ><span>Rally Roadbook</span></router-link
            >
          </li>
          <li class="h-[1px] bg-white px-10"></li>
          <li class="px-3">
            <router-link to="/how-to-create-a-cross-country" @click="toggleMenu"
              ><span>Create Cross Country Roadbook</span></router-link
            >
          </li>
          <li class="px-3 tracking-[-1.5px]">
            <router-link to="/fim-fia-roadbook-specs-rules" @click="toggleMenu"
              ><span
                >Cross Country FIA Roadbook Specs &amp; Rules</span
              ></router-link
            >
          </li>
          <li class="h-[1px] bg-white px-10"></li>
          <li class="px-3">
            <router-link to="/how-to-create-a-road-rally" @click="toggleMenu"
              ><span>Create Road Rally Roadbook</span></router-link
            >
          </li>
          <li class="px-3 tracking-[-1px]">
            <router-link to="/fia-roadbook-specs-rules" @click="toggleMenu"
              ><span
                >Road Rally FIA Roadbook Specs &amp; Rules</span
              ></router-link
            >
          </li>
          <li class="h-[1px] bg-white px-10"></li>
          <li class="px-3 tracking-[-1px]">
            <router-link to="/time-speed-distance" @click="toggleMenu"
              ><span>Create time speed distance roadbook</span></router-link
            >
          </li>
          <li class="h-[1px] bg-white px-10"></li>
          <li class="px-3">
            <router-link to="/pro-features" @click="toggleMenu"
              ><span>PRO FEATURES</span></router-link
            >
          </li>
          <li class="h-[1px] bg-white px-10"></li>
          <li class="px-3">
            <router-link
              to="/mobile-roadbook-reader"
              class=""
              @click="toggleMenu"
              ><span>MOBILE ROADBOOK READER</span></router-link
            >
          </li>
          <li class="px-3">
            <router-link to="/timing-scoring" class="" @click="toggleMenu"
              ><span>TIMING &amp; SCORING</span></router-link
            >
          </li>
          <li class="px-3">
            <a
              target="_blank"
              rel="noopener"
              href="http://advrider.com/index.php?threads/rally-navigator-create-rally-roadbooks-with-google-earth-and-gps.851881/"
              class=""
              ><span>FORUM</span></a
            >
          </li>
          <li class="px-3">
            <a
              target="_blank"
              rel="noopener"
              href="http://www.rallymotoshop.com/"
              class=""
              ><span>RALLY NAVIGATION EQUIPMENT</span></a
            >
          </li>
          <li class="px-3">
            <router-link to="/about" class="" @click="toggleMenu"
              ><span>ABOUT</span></router-link
            >
          </li>
          <li class="px-3">
            <router-link to="/whats-new" class="" @click="toggleMenu"
              ><span>WHAT'S NEW</span
              ><span
                v-if="recent"
                class="ml-1 px-1 rounded-sm bg-[#FF0000] text-white text-[10px] align-middle"
                >NEW</span
              ></router-link
            >
          </li>
          <!-- <li class="flex h-full px-3 items-center">
            <router-link to="/subscriptions"><span>Upgrade</span></router-link>
          </li> -->
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { hasRecentRelease } from '../content/releases';

export default {
  name: 'HamburgerMenu',
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    recent: () => hasRecentRelease(),
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style scoped>
.download {
  text-shadow: 1px 1px 2px black, 0 0 25px red, 0 0 5px darkred !important;
  font-weight: bold !important;
}
</style>
